export default __webpack_public_path__ + "static/media/102.b5bcb653.jpg";